// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__R0DYy","title":"Gallery_title__YVID4","gallery2":"Gallery_gallery2__HLXn2","col":"Gallery_col__it9FJ","row":"Gallery_row__8s4iN"};